import { ReactComponent as ArrowIconSVG } from '@/assets/icons/ArrowIcon.svg';
import { SVGProps } from 'react';

const ArrowIcon = (props: SVGProps<SVGSVGElement>) => <ArrowIconSVG {...props} />;

export default ArrowIcon;
